import { EChartService } from './echart.service';
import { SchoolGroupTrendAnalysis, GrowthMindsetMapData } from '@/models/school-group/school-group-trend-analysis';
import i18n from '@/i18n';

export class TrendanalysisGrowthMindsetMapEchartService extends EChartService {
  self: any;
  val: number;
  data: GrowthMindsetMapData[];

  constructor() {
    super();
    this.data = [];
    this.series = [];
    this.labels = [];
  }

  /**
   * AIGROW2-184 箱ひげ図にデータテーブルを追加
   * 箱ひげ図のみにデータを表形式で表示する
   * EChartService が箱ひげ図以外のグラフでも共通なので、空配列を返すだけのものを追加しています
   * subTableColmuns
   * subTableData
   */
  get subTableColmuns(): any[] {
    return [];
  }
  get subTableData(): any[] {
    return [];
  }

  get allData(): GrowthMindsetMapData[] {
    return [...this.data];
  }

  get hasUnderMinus50XPosData(): boolean {
    return this.allData.filter((d: any) => d.xPos <= -1).length > 0;
  }

  get hasUnderMinus50YPosData(): boolean {
    return this.allData.filter((d: any) => d.yPos <= -1).length > 0;
  }

  get isShowUnderMinus50Data(): boolean {
    return this.hasUnderMinus50XPosData || this.hasUnderMinus50YPosData;
  }

  get options() {
    return {
      toolbox: {
        show: true,
        top: '50',
        right: -5,
        itemSize: 15,
        feature: {
          dataZoom: { show: true, title: { zoom: i18n.t('ENLARGE').toString(), back: i18n.t('UNDO').toString() } },
          restore: { show: true, title: i18n.t('RESET').toString() },
        },
      },
      title: [
        { left: 'center', top: 10, text: i18n.t('GROWTH_MINDSET').toString() },
        {
          show: true,
          text: i18n.t('GROWTH_MIND_SET_MAP_DESC_ZONE_3').toString(),
          textStyle: {
            color: 'pink',
          },
          top: '3%',
          left: '0%',
        },
        {
          show: true,
          text: i18n.t('GROWTH_MIND_SET_MAP_DESC_ZONE_1').toString(),
          textStyle: {
            color: 'purple',
          },
          top: '3%',
          right: '0%',
        },
        {
          show: true,
          text: i18n.t('GROWTH_MIND_SET_MAP_DESC_ZONE_4').toString(),
          textStyle: {
            color: 'orange',
          },
          bottom: '0%',
          left: '0%',
        },
        {
          show: true,
          text: i18n.t('GROWTH_MIND_SET_MAP_DESC_ZONE_2').toString(),
          textStyle: {
            color: 'lime',
          },
          bottom: '0%',
          right: '0%',
        },
      ],
      legend: {
        data: this.labels,
        top: 100,
        right: 0,
        orient: 'vertical',
      },
      grid: {
        show: false,
      },
      xAxis: {
        type: 'value',
        name: i18n.t('SELF_EFFICACY').toString(),
        nameTextStyle: {
          fontSize: 14,
          fontWeight: 'bold',
        },
        nameLocation: 'center',
        axisLine: {
          onZero: false,
        },
        nameGap: 30,
        splitNumber: 9,
        max: 100,
        min: this.isShowUnderMinus50Data ? -100 : -50,
      },
      yAxis: {
        type: 'value',
        name: i18n.t('SELF_ESTEEM').toString(),
        nameTextStyle: {
          fontSize: 14,
          fontWeight: 'bold',
        },
        nameLocation: 'center',
        axisLine: {
          onZero: false,
        },
        nameGap: 30,
        splitNumber: 9,
        max: 100,
        min: this.isShowUnderMinus50Data ? -100 : -50,
      },
      series: this.series,
    };
  }

  addSeries(SchoolGroupTrendAnalysis: SchoolGroupTrendAnalysis): void {
    this.data.push(...SchoolGroupTrendAnalysis.growthMindsetMap.latestData);
    const name: string = `SN-${this.labels.length + 1}`;
    this.labels.push(name);
    this.series.push({
      name: name,
      symbolSize: 10,
      data: SchoolGroupTrendAnalysis.growthMindsetMap.latestData.map(this.generateSeriesData),
      type: 'scatter',
    });
  }

  generateSeriesData = (d: GrowthMindsetMapData) => {
    const { xPos, yPos } = d;
    const displayXPos = 50 * xPos;
    const displayYPos = 50 * yPos;
    return {
      name: d.fullName,
      isLink: true,
      studentID: d.student.studentID,
      value: [displayXPos, displayYPos],
      label: {
        show: true,
        formatter: '{b}',
        color: '#000000',
        fontSize: 10,
        position: 'top',
        distance: 3,
      },
    };
  };
}
